import React from 'react';
import styles, { item, hover, title, wrapLink } from './Items.module.css';
import { COFFEE } from '../../utils/constants';
import Image from '../UI/Image';
import { string, func, arrayOf, shape } from 'prop-types';

const Items = ({ onItemSelected, items, pageType }) => (
  <div className={styles.items}>

    {items.map(({ name, country, url, price, id }) => {
      if (pageType === COFFEE) {
        return (
          <div
            className={wrapLink}
            key={id}
            onClick={() => onItemSelected(id)}
          >
            <div className={`${item} ${hover}`}>
              <Image src={`${url}`} alt="coffee" />
              <div className={title}>
                {name}
              </div>
              <div className={styles.country}>{country}</div>
              <div className={styles.price}>{price}</div>
            </div>
          </div>
        )
      } else {
        return (
          <div className={item} key={id}>
            <Image src={`${url}`} alt="coffee" />
            <div className={title}>
              {name}
            </div>
            <div className={styles.country}>{country}</div>
            <div className={styles.price}>{price}</div>
          </div>
        )
      }
    })}

  </div>
)

Items.propTypes = {
  onItemSelected: func,
  pageType: string,
  items: arrayOf(shape({
    name: string,
    country: string,
    url: string,
    price: string,
    id: string.isRequired,
  }))
}

Items.defaultProps = {
  onItemSelected: () => { },
  pageType: '',
  items: [{
    name: '',
    country: '',
    url: '',
    price: '',
  }]
}

export default Items
